if (!customElements.get("variant-selects")) {
  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === "true";
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener("change", this.onVariantChange);
      this.other = Array.from(
        document.querySelectorAll("variant-selects"),
      ).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest(".thb-product-detail");
      this.productSlider =
        this.productWrapper?.querySelector(".product-images");
      this.hideVariants = this.dataset.hideVariants === "true";
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent("product:variant-change", {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
        } else if (fieldset.querySelectorAll("input").length) {
          this.options.push(fieldset.querySelector("input:checked").value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      fieldsets.forEach((item, i) => {
        const label = item.querySelector(".form__label__value");
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === "false") {
        return;
      }
      if (this.other.length) {
        const fieldsets = this.other[0].querySelectorAll("fieldset"),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector("select")) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll("input").length) {
            fieldsets_array[i].querySelector(
              `input[value='${option}']`,
            ).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const thumbnails = this.productWrapper.querySelector(
        ".product-thumbnail-container",
      );

      this.setActiveMedia(
        `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        this.productSlider,
        thumbnails,
      );
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      if (!productSlider) return;
      const flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);
      if (flkty && this.hideVariants) {
        if (
          productSlider.querySelector(
            ".product-images__slide.is-initial-selected",
          )
        ) {
          productSlider
            .querySelector(".product-images__slide.is-initial-selected")
            .classList.remove("is-initial-selected");
        }
        [].forEach.call(
          productSlider.querySelectorAll(
            ".product-images__slide-item--variant",
          ),
          (el) => {
            el.classList.remove("is-active");
          },
        );

        activeMedia.classList.add("is-active");
        activeMedia.classList.add("is-initial-selected");

        this.setImageSetMedia();

        if (thumbnails) {
          const activeThumb = thumbnails.querySelector(thumbId);

          if (
            thumbnails.querySelector(".product-thumbnail.is-initial-selected")
          ) {
            thumbnails
              .querySelector(".product-thumbnail.is-initial-selected")
              .classList.remove("is-initial-selected");
          }
          [].forEach.call(
            thumbnails.querySelectorAll(".product-images__slide-item--variant"),
            (el) => {
              el.classList.remove("is-active");
            },
          );

          activeThumb.classList.add("is-active");
          activeThumb.classList.add("is-initial-selected");
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);
      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`,
      );
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`,
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector(
        ".pickup-availability-wrapper",
      );

      if (!pickUpAvailability) return;

      if (
        this.currentVariant &&
        this.currentVariant.available &&
        pickUpAvailability.fetchAvailability
      ) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`,
        `stock-notice-${this.dataset.section}`,
      ];
    }

    renderProductInfo() {
      const sections = this.getSectionsToRender();

      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + "--sticky");

            if (price) price.classList.remove("visibility-hidden");
            if (price_fixed) price_fixed.classList.remove("visibility-hidden");
          });
          this.toggleAddButton(
            !this.currentVariant.available,
            window.theme.variantStrings.soldOut,
          );
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`,
      );
      if (!productForm) return;

      const productTemplate = productForm
        .closest(".product-form")
        .getAttribute("template");
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button",
      );

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text",
        );

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute("disabled", "disabled");
          if (text) submitButtonText.dataset.content = text;
        } else {
          submitButton.removeAttribute("disabled");
          submitButton.classList.remove("loading");

          if (productTemplate?.includes("pre-order")) {
            submitButtonText.dataset.content =
              window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.dataset.content =
              window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button",
      );
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(
        `price-${this.dataset.section}--sticky`,
      );

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text",
        );
        if (!submitButton) return;
        submitButtonText.dataset.content =
          window.theme.variantStrings.unavailable;
        submitButton.classList.add("sold-out");
      });
      if (price) price.classList.add("visibility-hidden");
      if (price_fixed) price_fixed.classList.add("visibility-hidden");
    }

    setDisabled() {
      if (this.isDisabledFeature != "true") {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data && this.currentVariant) {
        const selected_options = this.currentVariant.options.map(
          (value, index) => {
            return {
              value,
              index: `option${index + 1}`,
            };
          },
        );
        const available_options = this.createAvailableOptionsTree(
          variant_data,
          selected_options,
        );

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector("select")) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]",
                  ).disabled = true;
                } else {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]",
                  ).disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll("input").length) {
              fieldset.querySelectorAll("input").forEach((input, input_i) => {
                input.classList.toggle(
                  "is-disabled",
                  fieldset_options[input_i].isUnavailable,
                );
              });
            }
          }
        });
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    }

    setImageSet() {
      if (!this.productSlider) return;

      const dataSetEl = this.productSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector(
          '.product-form__input[data-handle="' + this.imageSetName + '"]',
        ).dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;

        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      const setValue = this.getImageSetName(
        this.currentVariant[this.imageSetIndex],
      );
      const group = this.imageSetName + "_" + setValue;
      const selected_set_images = this.productWrapper.querySelectorAll(
          `.product-images__slide[data-set-name="${this.imageSetName}"]`,
        ),
        selected_set_thumbs = this.productWrapper.querySelectorAll(
          `.product-thumbnail[data-set-name="${this.imageSetName}"]`,
        );

      if (this.hideVariants) {
        // Product images
        this.productWrapper
          .querySelectorAll(".product-images__slide")
          .forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
        selected_set_images.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper
          .querySelectorAll(".product-thumbnail")
          .forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
        selected_set_thumbs.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });
      }
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            let entry = options[index].find(
              (option) => option.value === variant[index],
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }

            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce(
              (count, { value, index }) => {
                return variant[index] === value ? count + 1 : count;
              },
              0,
            );

            // Only enable an option if an available variant matches all but one current selected value
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }

            // Make sure if a variant is unavailable, disable currently selected option
            if (
              (!this.currentVariant || !this.currentVariant.available) &&
              selected_options.find(
                (option) =>
                  option.value === entry.value && index === option.index,
              )
            ) {
              entry.isUnavailable = true;
            }

            // First option is always enabled
            if (index === "option1") {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }
          });

          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        },
      );
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define("variant-selects", VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked,
        ).value;
      });
    }
  }

  customElements.define("variant-radios", VariantRadios);
}

if (!customElements.get("product-slider")) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("change", this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest(".thb-product-detail");
      this.quickView = this.closest("#Product-Drawer-Content");
      this.thumbnail_container = this.product_container.querySelector(
        ".product-thumbnail-container",
      );
      this.video_containers = this.querySelectorAll(
        ".product-single__media-external-video--play",
      );
      ((this.progress_bar = this.product_container.querySelector(
        ".flickity-progress--bar",
      )),
        this.setOptions());
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == "true";
      this.thumbnails =
        this.thumbnail_container?.querySelectorAll(".product-thumbnail");
      this.prev_button = this.querySelector(".flickity-prev");
      this.next_button = this.querySelector(".flickity-next");
      this.images = this.querySelectorAll("img");
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        cellAlign: this.quickView ? "left" : "right",
        adaptiveHeight: !this.quickView,
        initialIndex: ".is-initial-selected",
        prevNextButtons: false,
        fade: false,
        cellSelector: ".product-images__slide.is-active",
        on: {
          ready: () => {
            this.images.forEach((img) => {
              img.addEventListener("lazyloaded", () => {
                this.flkty.resize();
              });
            });
          },
          dragStart: () => {
            this.flkty.slider.childNodes.forEach(
              (slide) => (slide.style.pointerEvents = "none"),
            );
          },
          dragEnd: () => {
            this.flkty.slider.childNodes.forEach(
              (slide) => (slide.style.pointerEvents = "all"),
            );
          },
        },
      };
      if (this.quickView) {
        this.options.wrapAround = false;
      }
      if (this.progress_bar) {
        this.options.on.scroll = (progress) => {
          progress = Math.max(0, Math.min(1, progress));
          this.progress_bar.style.width = progress * 100 + "%";
        };
      }
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      if (this.prev_button) {
        const prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener("click", (event) => {
          this.flkty.previous();
        });
        prev.addEventListener("keyup", (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        const next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener("click", (event) => {
          this.flkty.next();
        });
        next.addEventListener("keyup", (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector("button").addEventListener("click", () => {
          container.setAttribute("hidden", "");
        });
      });
      this.flkty.on("settle", (index) => {
        this.selectedIndex = index;
      });
      this.flkty.on("change", (index) => {
        const previous_slide = this.flkty.cells[this.selectedIndex].element,
          previous_media = previous_slide.querySelector(
            ".product-single__media",
          );

        if (this.thumbnails) {
          const active_thumbs = Array.from(this.thumbnails).filter((element) =>
              element.classList.contains("is-active"),
            ),
            active_thumb = active_thumbs[index]
              ? active_thumbs[index]
              : active_thumbs[0];

          this.thumbnails.forEach((item, i) => {
            item.classList.remove("is-initial-selected");
          });
          active_thumb.classList.add("is-initial-selected");

          requestAnimationFrame(() => {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left:
                active_thumb.offsetLeft -
                windowHalfWidth +
                active_thumb.clientWidth / 2,
              top:
                active_thumb.offsetTop -
                windowHalfHeight +
                active_thumb.clientHeight / 2,
              behavior: "smooth",
            });
          });
        }

        // Stop previous video
        if (
          previous_media.classList.contains(
            "product-single__media-external-video",
          )
        ) {
          if (previous_media.dataset.provider === "youtube") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: "",
              }),
              "*",
            );
          } else if (previous_media.dataset.provider === "vimeo") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                method: "pause",
              }),
              "*",
            );
          }
          previous_media
            .querySelector(".product-single__media-external-video--play")
            .removeAttribute("hidden");
        } else if (
          previous_media.classList.contains(
            "product-single__media-native-video",
          )
        ) {
          previous_media.querySelector("video").pause();
        }
      });

      if (this.thumbnails && !this.thumbnail_container.dataset.init) {
        setTimeout(() => {
          const active_thumbs = Array.from(this.thumbnails).filter(
            (element) => element.clientWidth > 0,
          );
          active_thumbs.forEach((thumbnail, index) => {
            thumbnail.addEventListener("click", () => {
              this.thumbnailClick(thumbnail, index);
            });
          });
          this.thumbnail_container.addEventListener("click", (e) => {
            const count = Math.min(
              Math.max(
                this.thumbnail_container.querySelectorAll(".is-active").length,
                1,
              ),
              4,
            );
            this.thumbnail_container.style.setProperty(
              "--thumbnail-width",
              count * 63 + 19 + "px",
            );
            if (!this.thumbnail_container.classList.contains("extended")) {
              this.thumbnail_container.classList.add("extended");
            } else {
              if (e.target.nodeName == "BUTTON") {
                this.thumbnail_container.classList.remove("extended");
              }
              e.preventDefault();
            }
            if (!this.thumbnail_container.classList.contains("extended")) {
              const active_thumb = this.thumbnail_container.querySelector(
                ".is-initial-selected",
              );
              setTimeout(() => {
                active_thumb.parentElement.scrollTo({
                  left: Math.max(active_thumb.offsetLeft, 0),
                  top: 0,
                  behavior: "smooth",
                });
              }, 300);
            }
          });
          this.thumbnail_container.dataset.init = true;
        });
      }
    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, (el) => {
        el.classList.remove("is-initial-selected");
      });
      thumbnail.classList.add("is-initial-selected");
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll(".product-single__media-zoom").length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(
        this.querySelectorAll(
          ".product-images__slide.is-active .product-single__media-image",
        ),
      );

      return this.activeImages.map((item) => {
        const index = [].indexOf.call(
          item.parentNode.parentNode.children,
          item.parentNode,
        );

        const activelink = item.querySelector(".product-single__media-zoom");

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute("href"),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll(".product-single__media-zoom");
      this.pswpElement = document.querySelectorAll(".pswp")[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector(
              ".product-images__slide.is-selected",
            ),
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width,
          };
        },
      };

      this.links.forEach((link) => {
        link.addEventListener("click", (e) => this.zoomClick(e, link));
      });
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== "undefined") {
        const pswp = new PhotoSwipe(
          this.pswpElement,
          PhotoSwipeUI_Default,
          this.items,
          this.pswpOptions,
        );
        pswp.listen("firstUpdate", () => {
          pswp.listen("parseVerticalMargin", (item) => {
            item.vGap = {
              top: 50,
              bottom: 50,
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define("product-slider", ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(
        `product-form-${this.dataset.section}`,
      );
      this.form.querySelector("[name=id]").disabled = false;
      if (!this.sticky) {
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector("cart-notification");
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === "true";
    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button",
      );

      if (
        Array.from(submitButtons).some((submitButton) =>
          submitButton.classList.contains("loading"),
        )
      ) {
        return;
      }

      submitButtons.forEach((submitButton) => {
        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
      });

      this.handleErrorMessage();

      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
      };

      const formData = new FormData(this.form);

      formData.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section),
      );
      formData.append("sections_url", window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent("product:variant-error", {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent("cart:item-added", {
            product: Object.hasOwn(response, "items")
              ? response.items[0]
              : response,
          });
          dispatchCustomEvent("button-click:add-to-cart", {
            product: Object.hasOwn(response, "items")
              ? response.items[0]
              : response,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
          });
          if (document.querySelector(".product-add-to-cart-sticky-modal")) {
            document
              .querySelector(".product-add-to-cart-sticky-modal")
              .removeAttribute("open");
          }
        });
    }
    getSectionsToRender() {
      return [
        {
          id: "Cart",
          section: "cart-v2",
          selector: ".thb-cart-form",
        },
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector,
        );

        if (typeof Cart !== "undefined") {
          new Cart().renderContents(parsedState);
        }
        if (section.id == "Cart-Drawer") {
          elementToReplace.removeProductEvent();
          elementToReplace.notesToggle();
          elementToReplace.termsCheckbox();
          elementToReplace.updateFreeShipping();
        }
      });

      const product_drawer = document.getElementById("Product-Drawer");
      const search_drawer = document.getElementById("Search-Drawer");
      const cart_drawer = document.getElementById("Cart-Drawer");

      if (search_drawer.classList.contains("active")) {
        search_drawer.classList.remove("active");
      }
      if (product_drawer && product_drawer.contains(this)) {
        // Close product drawer and open cart drawer
        product_drawer.classList.remove("active");
        this.body.classList.remove("open-cc--product");
        const quickViewButton = document.querySelector(
          'quick-view[aria-expanded="true"]',
        );
        if (quickViewButton) {
          quickViewButton.ariaExpanded = false;
        }
        if (cart_drawer) {
          this.body.classList.add("open-cc");
          cart_drawer.classList.add("active");
          if (cart_drawer.button) {
            cart_drawer.button.ariaExpanded = true;
          }
          dispatchCustomEvent("cart-drawer:open");

          // Trap focus and handle escape key
          setTimeout(() => {
            cart_drawer.focusTrap.listenForEscape();
            cart_drawer.focusTrap.trapFocus(cart_drawer);
          }, 200);
        }
      } else if (cart_drawer) {
        this.body.classList.add("open-cc", "overflow-hidden");
        cart_drawer.classList.add("active");
        if (cart_drawer.button) {
          cart_drawer.button.ariaExpanded = true;
        }
        dispatchCustomEvent("cart-drawer:open");

        // Trap focus and handle escape key
        setTimeout(() => {
          cart_drawer.focusTrap.listenForEscape();
          cart_drawer.focusTrap.trapFocus(cart_drawer);
        }, 200);
      }
    }
    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(".product-form__error-message-wrapper");
      if (!this.errorMessageWrapper) return;
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");

      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }

  customElements.define("product-form", ProductForm);
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get("product-add-to-cart-sticky")) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setupObservers();
      this.drawer = document.getElementById(this.dataset.target);
      this.addEventListener("click", this.onClick.bind(this));
    }
    onClick() {
      this.drawer.show();
    }
    setupObservers() {
      const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.target === footer) {
                if (entry.intersectionRatio > 0) {
                  this.classList.remove("sticky--visible");
                } else if (entry.intersectionRatio == 0 && this.formPassed) {
                  this.classList.add("sticky--visible");
                }
              }
              if (entry.target === form) {
                const boundingRect = form.getBoundingClientRect();

                if (
                  entry.intersectionRatio === 0 &&
                  window.scrollY > boundingRect.top + boundingRect.height
                ) {
                  this.formPassed = true;
                  this.classList.add("sticky--visible");
                } else if (entry.intersectionRatio === 1) {
                  this.formPassed = false;
                  this.classList.remove("sticky--visible");
                }
              }
            });
          },
          {
            threshold: [0, 1],
          },
        ),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById("footer");
      this.formPassed = false;
      observer.observe(form);
    }
  }

  customElements.define("product-add-to-cart-sticky", ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

document.addEventListener("button-click:add-to-cart", (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      items: [
        {
          item_id: data.detail.product.sku,
          item_name: data.detail.product.product_title,
          price: data.detail.product.price / 100,
          currency: window.Shopify.currency.active ?? "USD",
          item_category: data.detail.product.product_type ?? "",
          item_variant: data.detail.product.variant_title,
          quantity: data.detail.product.quantity,
        },
      ],
    },
  });
});

document.addEventListener("product:variant-change", (event) => {
  const { variant, sectionId } = event.detail;
  const inventoryNotice = document.getElementById(
    `variant-inventory-${sectionId}`,
  );
  const stockNotice = document.getElementById(`stock-notice-${sectionId}`);

  const variantSelects = document.getElementById(
    `variant-selects-${sectionId}`,
  );
  const inventoryDataEl = variantSelects?.querySelector(
    "[data-variant-inventory]",
  );
  let inventoryData = {};

  if (inventoryDataEl) {
    try {
      inventoryData = JSON.parse(inventoryDataEl.textContent);
    } catch (e) {
      console.error("Failed to parse inventory data", e);
    }
  }

  const variantInventory = variant ? inventoryData[variant.id] : null;
  const showNotice =
    variantInventory &&
    variantInventory.available &&
    variantInventory.inventory_quantity >= 1 &&
    variantInventory.inventory_quantity <= 10;

  if (inventoryNotice) {
    const template = inventoryNotice.dataset.inventoryTemplate;
    if (showNotice) {
      const message = template.replace(
        "[QTY]",
        variantInventory.inventory_quantity,
      );
      inventoryNotice.innerHTML = `<span class="variant-inventory-text">${message}</span>`;
    } else {
      inventoryNotice.innerHTML = "";
    }
  }

  if (stockNotice) {
    const template = stockNotice.dataset.inventoryTemplate;
    if (showNotice) {
      const message = template.replace(
        "[QTY]",
        variantInventory.inventory_quantity,
      );
      stockNotice.innerHTML = `<div class="product-stock-notice">${message}</div>`;
    } else {
      stockNotice.innerHTML = "";
    }
  }
});

// <PRODUCT_GALLERY>
const initializeProductThumbnails = (emblaApiMain, viewportNode) => {
  const getSlides = () => [
    ...viewportNode.querySelectorAll(".embla-thumbs__slide:not([hidden])"),
  ];
  const thumbsRoot = viewportNode.closest(".embla-thumbs");
  const topArrow = thumbsRoot.querySelector(
    ".embla-thumbs__scroll-indicator--top",
  );
  const bottomArrow = thumbsRoot.querySelector(
    ".embla-thumbs__scroll-indicator--bottom",
  );
  const dragState = {
    isPointerDown: false,
    isDragging: false,
    startY: 0,
    startScrollTop: 0,
    pointerId: null,
  };
  const dragThreshold = 4;

  const updateArrows = () => {
    const maxScroll = viewportNode.scrollHeight - viewportNode.clientHeight;
    const canScrollUp = viewportNode.scrollTop > 1;
    const canScrollDown =
      maxScroll > 1 && viewportNode.scrollTop < maxScroll - 1;
    const slides = getSlides();
    const selectedIndex = emblaApiMain.selectedScrollSnap();
    const isFirstSelected = selectedIndex <= 0;
    const isLastSelected = selectedIndex >= slides.length - 1;

    // Visibility is driven by thumb scroll position.
    topArrow.classList.toggle(
      "embla-thumbs__scroll-indicator--visible",
      canScrollUp,
    );
    bottomArrow.classList.toggle(
      "embla-thumbs__scroll-indicator--visible",
      canScrollDown,
    );

    // Disabled state is driven by which main image is selected.
    topArrow.classList.toggle(
      "embla-thumbs__scroll-indicator--disabled",
      isFirstSelected,
    );
    bottomArrow.classList.toggle(
      "embla-thumbs__scroll-indicator--disabled",
      isLastSelected,
    );
    topArrow.disabled = isFirstSelected;
    bottomArrow.disabled = isLastSelected;
    topArrow.setAttribute("aria-disabled", String(isFirstSelected));
    bottomArrow.setAttribute("aria-disabled", String(isLastSelected));
  };

  const keepThumbnailInView = (slide) => {
    const viewportBounds = viewportNode.getBoundingClientRect();
    const slideBounds = slide.getBoundingClientRect();
    const arrowHeight = topArrow.offsetHeight;
    const visibleTop = viewportBounds.top + arrowHeight;
    const visibleBottom = viewportBounds.bottom - arrowHeight;

    if (slideBounds.top < visibleTop) {
      viewportNode.scrollBy({
        top: slideBounds.top - visibleTop,
        behavior: "smooth",
      });
    } else if (slideBounds.bottom > visibleBottom) {
      viewportNode.scrollBy({
        top: slideBounds.bottom - visibleBottom,
        behavior: "smooth",
      });
    }
  };

  const endDrag = (event) => {
    if (!dragState.isPointerDown) return;

    const wasDragging = dragState.isDragging;
    const pointerId = dragState.pointerId;

    // Clear state before release so lostpointercapture can't re-enter.
    dragState.isPointerDown = false;
    dragState.isDragging = false;
    dragState.pointerId = null;
    viewportNode.classList.remove("embla-thumbs__viewport--dragging");

    if (pointerId !== null && viewportNode.hasPointerCapture?.(pointerId)) {
      viewportNode.releasePointerCapture(pointerId);
    }

    // Prevent the synthetic click that follows a drag gesture.
    if (wasDragging && event?.type === "pointerup") {
      const suppressClick = (clickEvent) => {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
      };
      viewportNode.addEventListener("click", suppressClick, {
        capture: true,
        once: true,
      });
    }
  };

  viewportNode.addEventListener("pointerdown", (event) => {
    if (event.pointerType === "mouse" && event.button !== 0) return;

    dragState.isPointerDown = true;
    dragState.isDragging = false;
    dragState.startY = event.clientY;
    dragState.startScrollTop = viewportNode.scrollTop;
    dragState.pointerId = event.pointerId;
  });

  viewportNode.addEventListener("pointermove", (event) => {
    if (!dragState.isPointerDown) return;

    const deltaY = event.clientY - dragState.startY;

    if (!dragState.isDragging) {
      if (Math.abs(deltaY) < dragThreshold) return;
      dragState.isDragging = true;
      viewportNode.classList.add("embla-thumbs__viewport--dragging");
      viewportNode.setPointerCapture?.(dragState.pointerId);
    }

    event.preventDefault();
    viewportNode.scrollTop = dragState.startScrollTop - deltaY;
  });

  viewportNode.addEventListener("pointerup", endDrag);
  viewportNode.addEventListener("pointercancel", endDrag);
  viewportNode.addEventListener("lostpointercapture", endDrag);

  // Prevent native image drag from fighting custom drag-to-scroll.
  viewportNode.querySelectorAll("img").forEach((image) => {
    image.setAttribute("draggable", "false");
    image.addEventListener("dragstart", (event) => event.preventDefault());
  });

  viewportNode.querySelectorAll(".embla-thumbs__slide").forEach((slide) => {
    slide.addEventListener("click", (event) => {
      if (dragState.isDragging) {
        event.preventDefault();
        return;
      }
      const index = getSlides().indexOf(slide);
      if (index >= 0) emblaApiMain.scrollTo(index);
    });
  });
  topArrow.addEventListener("click", () => {
    if (topArrow.disabled) return;
    emblaApiMain.scrollPrev();
  });
  bottomArrow.addEventListener("click", () => {
    if (bottomArrow.disabled) return;
    emblaApiMain.scrollNext();
  });
  viewportNode.addEventListener("scroll", updateArrows, { passive: true });

  // Recompute once the thumb strip is actually measurable (container-query
  // units and lazy thumbs can settle after the initial synchronous run).
  if (typeof ResizeObserver !== "undefined") {
    const resizeObserver = new ResizeObserver(() => updateArrows());
    resizeObserver.observe(viewportNode);
    const container = viewportNode.querySelector(".embla-thumbs__container");
    if (container) resizeObserver.observe(container);
  }
  window.addEventListener("load", updateArrows);

  const updateSelectedThumbnail = () => {
    const slides = getSlides();
    const selectedIndex = emblaApiMain.selectedScrollSnap();
    viewportNode.querySelectorAll(".embla-thumbs__slide").forEach((slide) => {
      slide.classList.remove("embla-thumbs__slide--selected");
      slide.querySelector("button")?.removeAttribute("aria-current");
    });
    const selectedSlide = slides[selectedIndex];
    if (selectedSlide) {
      selectedSlide.classList.add("embla-thumbs__slide--selected");
      selectedSlide
        .querySelector("button")
        ?.setAttribute("aria-current", "true");
      keepThumbnailInView(selectedSlide);
    }
    updateArrows();
  };

  emblaApiMain.on("select", updateSelectedThumbnail);
  emblaApiMain.on("reInit", updateSelectedThumbnail);
  updateSelectedThumbnail();
};

const initializeProductArrows = (emblaApi, viewportNode) => {
  const previousButton = viewportNode.querySelector(".embla__arrow--prev");
  const nextButton = viewportNode.querySelector(".embla__arrow--next");
  if (!previousButton || !nextButton) return;

  const updateArrowButtons = () => {
    const hasMultipleSlides = emblaApi.scrollSnapList().length > 1;
    previousButton.hidden = !hasMultipleSlides;
    nextButton.hidden = !hasMultipleSlides;
    previousButton.disabled = !emblaApi.canScrollPrev();
    nextButton.disabled = !emblaApi.canScrollNext();
  };

  previousButton.addEventListener("click", () => emblaApi.scrollPrev());
  nextButton.addEventListener("click", () => emblaApi.scrollNext());
  emblaApi.on("select", updateArrowButtons);
  emblaApi.on("reInit", updateArrowButtons);
  updateArrowButtons();
};

const initializeProductDots = (emblaApi, dotsNode) => {
  if (!dotsNode) return;

  let dotNodes = [];

  const createDotButtonHtml = () => {
    const dotTemplate = document.getElementById("embla-dot-template");
    if (!dotTemplate) return [];

    const snapList = emblaApi.scrollSnapList();
    dotsNode.innerHTML = snapList.reduce(
      (acc) => acc + dotTemplate.innerHTML,
      "",
    );

    return Array.from(dotsNode.querySelectorAll(".embla__dot"));
  };

  const addDotButtonClickHandlers = () => {
    dotNodes.forEach((dotNode, index) => {
      dotNode.setAttribute("aria-label", `Go to image ${index + 1}`);
      dotNode.addEventListener("click", () => emblaApi.scrollTo(index), false);
    });
  };

  const toggleDotButtonsActive = () => {
    if (!dotNodes.length) return;

    const previous = emblaApi.previousScrollSnap();
    const selected = emblaApi.selectedScrollSnap();

    dotNodes.forEach((dotNode, index) => {
      const isSelected = index === selected;
      dotNode.classList.toggle("embla__dot--selected", isSelected);
      if (isSelected) {
        dotNode.setAttribute("aria-current", "true");
      } else {
        dotNode.removeAttribute("aria-current");
      }
    });

    // previousScrollSnap can be out of range on first paint
    if (dotNodes[previous] && previous !== selected) {
      dotNodes[previous].classList.remove("embla__dot--selected");
    }
  };

  const createAndSetupDotButtons = () => {
    dotNodes = createDotButtonHtml();
    addDotButtonClickHandlers();
    toggleDotButtonsActive();
  };

  createAndSetupDotButtons();
  emblaApi.on("reInit", createAndSetupDotButtons);
  emblaApi.on("select", toggleDotButtonsActive);
};

const initializeProductLightbox = (
  wrapperNode,
  viewportNode,
  visibleMainSlides,
) => {
  if (wrapperNode.dataset.lightbox !== "true") return;
  if (typeof PhotoSwipe === "undefined") return;

  const pswpElement = document.querySelector(".pswp");
  if (!pswpElement) return;

  const buildItems = (slides) =>
    slides.map((slide) => ({
      src: slide.dataset.pswpSrc,
      msrc: slide.dataset.pswpMsrc,
      w: parseInt(slide.dataset.pswpWidth, 10),
      h: parseInt(slide.dataset.pswpHeight, 10),
      title: slide.dataset.pswpCaption || "",
      el: slide,
    }));

  const pswpOptions = {
    maxSpreadZoom: 2,
    loop: false,
    closeOnScroll: false,
    showHideOpacity: false,
    arrowKeys: true,
    history: false,
    captionEl: false,
    fullscreenEl: false,
    zoomEl: false,
    shareEl: false,
    counterEl: true,
    arrowEl: true,
    preloaderEl: true,
    getThumbBoundsFn: (index) => {
      const thumb = openItems[index] && openItems[index].el;
      if (!thumb) return null;
      const img = thumb.querySelector("img") || thumb;
      const pageYScroll =
        window.pageYOffset || document.documentElement.scrollTop;
      const rect = img.getBoundingClientRect();
      return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
    },
  };

  let openItems = [];

  const openLightbox = (clickedSlide) => {
    const slides = visibleMainSlides().filter(
      (slide) => slide.dataset.lightboxTrigger !== undefined,
    );
    const index = slides.indexOf(clickedSlide);
    if (index < 0) return;

    openItems = buildItems(slides);
    const pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, openItems, {
      ...pswpOptions,
      index,
    });
    pswp.init();
  };

  // Distinguish a genuine tap/click from an Embla drag/swipe gesture so the
  // lightbox only opens on a real click.
  const dragThreshold = 10;
  let pointerStartX = 0;
  let pointerStartY = 0;
  let pointerMoved = false;

  viewportNode.addEventListener("pointerdown", (event) => {
    pointerStartX = event.clientX;
    pointerStartY = event.clientY;
    pointerMoved = false;
  });
  viewportNode.addEventListener("pointermove", (event) => {
    if (
      Math.abs(event.clientX - pointerStartX) > dragThreshold ||
      Math.abs(event.clientY - pointerStartY) > dragThreshold
    ) {
      pointerMoved = true;
    }
  });

  viewportNode.addEventListener("click", (event) => {
    // Ignore the click that follows an Embla drag/swipe gesture.
    if (pointerMoved) return;
    const slide = event.target.closest("[data-lightbox-trigger]");
    if (!slide || !viewportNode.contains(slide)) return;
    openLightbox(slide);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (document.body.classList.contains("template-product")) {
    // Each product image should snap to the viewport's leading edge. Combined
    // with the CSS slide gap, this prevents fractional transforms from exposing
    // pixels from an adjacent image in some browser/device-pixel combinations.
    const OPTIONS = { align: "start" };

    const wrapperNode = document.querySelector(
      ".product-image-container .embla",
    );
    if (!wrapperNode) return;

    const viewportNodeMainCarousel =
      wrapperNode.querySelector(".embla__viewport");
    const viewportNodeThumbCarousel = wrapperNode.querySelector(
      ".embla-thumbs__viewport",
    );
    const dotsNode = wrapperNode.querySelector(".embla__dots");

    const visibleMainSlides = () => [
      ...viewportNodeMainCarousel.querySelectorAll(
        ".embla__slide:not([hidden])",
      ),
    ];
    const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, {
      ...OPTIONS,
      slides: visibleMainSlides(),
    });
    initializeProductThumbnails(emblaApiMain, viewportNodeThumbCarousel);
    initializeProductArrows(emblaApiMain, viewportNodeMainCarousel);
    initializeProductDots(emblaApiMain, dotsNode);
    initializeProductLightbox(
      wrapperNode,
      viewportNodeMainCarousel,
      visibleMainSlides,
    );

    const galleryOptionIndex = Number(wrapperNode.dataset.galleryOptionIndex);
    if (!Number.isNaN(galleryOptionIndex)) {
      const groupedSlide = wrapperNode.querySelector(
        '[data-gallery-group]:not([data-gallery-group="cart_only"])',
      );
      const galleryOption = groupedSlide?.dataset.galleryGroup.split("_")[0];
      let activeGroup = wrapperNode.dataset.activeGalleryGroup;

      document.addEventListener("product:variant-change", (event) => {
        if (
          String(event.detail.sectionId) !== wrapperNode.dataset.sectionId ||
          !event.detail.variant ||
          !galleryOption
        )
          return;

        const optionValue = event.detail.variant.options[galleryOptionIndex]
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-|-$/g, "");
        const selectedGroup = `${galleryOption}_${optionValue}`;

        if (selectedGroup === activeGroup) return;

        activeGroup = selectedGroup;
        wrapperNode.dataset.activeGalleryGroup = selectedGroup;

        wrapperNode.querySelectorAll("[data-gallery-group]").forEach((item) => {
          const group = item.dataset.galleryGroup;

          item.hidden = group === "cart_only" || group !== selectedGroup;
        });

        emblaApiMain.reInit({ slides: visibleMainSlides(), startIndex: 0 });
        const status = wrapperNode.querySelector("[data-gallery-status]");
        if (status) {
          status.textContent = `Product images updated for ${event.detail.variant.options[galleryOptionIndex]}.`;
        }
      });
    }
  }
});
// <END_PRODUCT_GALLERY>
